"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _IconWrapper = _interopRequireDefault(require("../IconWrapper"));

var _StyledLabel = _interopRequireDefault(require("../StyledLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterSimplePrimary = function FilterSimplePrimary(_ref) {
  var ariaLabel = _ref['aria-label'],
      active = _ref.active,
      text = _ref.text,
      Icon = _ref.badgeIcon,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'information' : _ref$badgeColor,
      count = _ref.count;
  var buttonText = isNaN(count) ? text : "".concat(count, " ").concat(text);
  return _react.default.createElement(_react.default.Fragment, null, Icon && _react.default.createElement(_IconWrapper.default, {
    badgeColor: badgeColor
  }, _react.default.createElement(Icon, {
    size: "small",
    role: "img",
    "aria-label": ariaLabel
  })), _react.default.createElement(_StyledLabel.default, {
    active: active,
    hasBadge: !!Icon,
    marginLeft: 1
  }, buttonText));
};

FilterSimplePrimary.propTypes = {
  active: _propTypes.default.bool,
  count: _propTypes.default.number,
  text: _propTypes.default.string.isRequired,
  badgeColor: _propTypes.default.string,
  badgeIcon: _propTypes.default.elementType
};
FilterSimplePrimary.defaultProps = {
  active: null,
  count: undefined,
  badgeColor: "".concat((0, _toColorString.default)(_color.default.status.information.medium)),
  badgeIcon: null
};
var _default = FilterSimplePrimary;
exports.default = _default;